

































import Vue, { PropOptions } from 'vue';
import { WordPath } from '@/game';

export default Vue.extend({
  props: {
    path: {
      type: Array,
      required: true,
    } as PropOptions<WordPath>,
  },
  data(): { radius: number; cell: number } {
    return {
      radius: 16,
      cell: 52, // FIXME: hardcoded to reflect size from Game.vue
    };
  },
  computed: {
    svgRects(): object[] {
      const path = this.path as WordPath;
      const size = this.cell as number;
      const radius = this.radius as number;
      const rects = [];
      let previous = path[0];

      for (let i = 1; i < path.length; i++) {
        const position = path[i];
        const x = size * (previous.x + 0.5);
        const y = size * (previous.y + 0.5);
        const dx = (position.x - previous.x);
        const dy = (position.y - previous.y);
        const angle = (180 / Math.PI) * Math.atan2(dy, dx);
        const width = (angle % 90 === 0) ? size : Math.sqrt(2) * size;
        const height = 2 * radius;

        rects.push({ x, y, width, height, angle });
        previous = position;
      }

      return rects;
    },
  },
});
